import { render, staticRenderFns } from "./TwilioIntegration.vue?vue&type=template&id=13a6add6&scoped=true&"
import script from "./TwilioIntegration.vue?vue&type=script&lang=js&"
export * from "./TwilioIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a6add6",
  null
  
)

export default component.exports